import { CRUDPathSegmentEn } from '@martech-solution/utils/constants';

const standardsQualityPath = {
  standardsQuality: '/erp/standards-quality',

  // QC TEMPLATE - MẪU ĐÁNH GIÁ CHẤT LƯỢNG
  qcTemplate: '/erp/standards-quality/qc-template',
  qcTemplateDetail: '/erp/standards-quality/qc-template' + CRUDPathSegmentEn.DETAIL,
  qcTemplateAdd: '/erp/standards-quality/qc-template' + CRUDPathSegmentEn.ADD,
  qcTemplateEdit: '/erp/standards-quality/qc-template' + CRUDPathSegmentEn.EDIT,

  // QC TEMPLATE - MẪU ĐÁNH GIÁ CHẤT LƯỢNG
  qcCheck: '/erp/standards-quality/qc-check',
  qcCheckDetail: '/erp/standards-quality/qc-check' + CRUDPathSegmentEn.DETAIL,
  qcCheckAdd: '/erp/standards-quality/qc-check' + CRUDPathSegmentEn.ADD,
  qcCheckEdit: '/erp/standards-quality/qc-check' + CRUDPathSegmentEn.EDIT,

  // PRODUCTION PLAN - KẾ HOẠCH SẢN XUẤT
  productionPlan: '/erp/standards-quality/production-plan',
  productionPlanDetail: '/erp/standards-quality/production-plan',
  productionPlanAdd: '/erp/standards-quality/production-plan' + CRUDPathSegmentEn.ADD,
  productionPlanEdit: '/erp/standards-quality/production-plan' + CRUDPathSegmentEn.EDIT,

  // ACCEPTANCE TRACKING - BÁO CÁI NGHIỆM THU
  acceptanceTracking: '/erp/standards-quality/acceptance-tracking',
  acceptanceTrackingDetail: '/erp/standards-quality/acceptance-tracking',
  acceptanceTrackingAdd: '/erp/standards-quality/acceptance-tracking' + CRUDPathSegmentEn.ADD,
  acceptanceTrackingEdit: '/erp/standards-quality/acceptance-tracking' + CRUDPathSegmentEn.EDIT,

  // STANDARD - DANH MỤC TIÊU CHUẨN
  standard: '/erp/standards-quality/standard',

  // CHECK LIST - DANH MỤC CHECK LIST
  checkList: '/erp/standards-quality/check-list',

  // CERTIFICATION ASSESSMENT PLAN - KẾ HOẠCH ĐÁNH GIÁ CÁC CHỨNG NHẬN
  certificationAssessmentPlan: '/erp/standards-quality/certification-assessment-plan',

  // QUALITY INSPECTION REQUIREMENT - YÊU CẦU KIỂM TRA CHÂT LƯỢNG
  qualityInspectionRequirement: '/erp/standards-quality/quality-inspection-requirement',

  // QUALITY CONTROL PROCESS - QUY TRÌNH KIỂM SOÁT CHẤT LƯỢNG
  qualityControlProcess: '/erp/standards-quality/quality-control-process',

  // MATERIAL QUALITY MANAGEMENT - QUẢN LÝ CHẤT LƯỢNG NVL
  materialQualityManagement: '/erp/standards-quality/material-quality-management',

  // QC RESULT - PHIẾU KIỂM SOÁT CHẤT LƯỢNG
  qcResult: '/erp/standards-quality/qc-result',
  qcResultDetail: '/erp/standards-quality/qc-result' + CRUDPathSegmentEn.DETAIL
};
export default standardsQualityPath;
